<div>
    <h2>{{'mantenimientoDenominaciones.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}}</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoDenominaciones.filters.producto' | translate}}</label>
                <app-filterable-list [itemsList]="productos" [selectedItem]="filtersForm.get('productoId')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoDenominaciones.filters.denominacion' | translate}}</label>
                <input type="text" formControlName="des">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
          title="{{'global.filtros.abrir' | translate}}">
          <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
          (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
          <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
          [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
          title="{{'global.filtros.limpiar' | translate}}">
          <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
          title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
          <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
      <div class="table-container">
        <table>
          <thead>
              <tr>
                  <th class="icon"></th>
                  <th class="icon"></th>
                  <th class="id sortable" (click)="toOrderBy('x=> x.id', 3)">
                    {{'mantenimientoDenominaciones.table.id' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.id', 3)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.des', 4)">
                    {{'mantenimientoDenominaciones.table.denominacion' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.des', 4)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.alias', 5)">
                    {{'mantenimientoDenominaciones.table.alias' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.alias', 5)"></i>
                    </div>
                  </th>
                  <th class="string sortable" (click)="toOrderBy('x=> x.Producto.DesProductoDefecto', 6)">
                    {{'mantenimientoDenominaciones.table.producto' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.Producto.DesProductoDefecto', 6)"></i>
                    </div>
                  </th>
                  <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.GruposEtiquetaDenominacion.Where(y=>y.GrupoEtiqueta.TipoConfeccionId==1).FirstOrDefault().GrupoEtiqueta.Des', 7)">
                    {{'mantenimientoDenominaciones.table.grupoEtiquetaCaja' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.GruposEtiquetaDenominacion.Where(y=>y.GrupoEtiqueta.TipoConfeccionId==1).FirstOrDefault().GrupoEtiqueta.Des', 7)"></i>
                    </div>
                  </th>
                  <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.GruposEtiquetaDenominacion.Where(y=>y.GrupoEtiqueta.TipoConfeccionId==2).FirstOrDefault().GrupoEtiqueta.Des', 8)">
                    {{'mantenimientoDenominaciones.table.grupoEtiquetaPallet' | translate}}
                    <div class="sortable-icons">
                      <i [ngClass]="getIcon('x=> x.GruposEtiquetaDenominacion.Where(y=>y.GrupoEtiqueta.TipoConfeccionId==2).FirstOrDefault().GrupoEtiqueta.Des', 8)"></i>
                    </div>
                  </th>
                  <th class="icon">{{'mantenimientoDenominaciones.table.permisoLectura' | translate}}</th>
                  <th class="actions">
                      <i class="fas fa-plus" (click)="create()" title="{{'mantenimientoDenominaciones.tituloNew' | translate}}"></i>
                  </th>
              </tr>
          </thead>
          <tbody *ngFor="let denominacion of denominaciones; let i=index; trackBy: trackByDenominacionId">
              <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                  <td class="icon">
                      <i *ngIf="denominacion.tieneMarcasAsociadas" class="fa-regular fa-circle-check fa-sm" title="{{'titles.marcasAsociadas' | translate}}"></i>
                      <i *ngIf="!denominacion.tieneMarcasAsociadas" style="color:red" class="fa-regular fa-circle-xmark fa-sm" title="{{'titles.sinMarcasAsociadas' | translate}}"></i>
                  </td>
                  <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                    title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                  </td>
                  <td class="id">{{denominacion.id}}</td>
                  <td class="string">{{denominacion.des}}</td>
                  <td class="string">{{denominacion.alias}}</td>
                  <td class="string" >{{denominacion.desProducto ? denominacion.desProducto : ''}}</td>
                  <td class="string-longest">{{denominacion.desGrupoEtiquetaCaja ? denominacion.desGrupoEtiquetaCaja : 'mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas' | translate}}</td>
                  <td class="string-longest">{{denominacion.desGrupoEtiquetaPallet ? denominacion.desGrupoEtiquetaPallet : 'mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas' | translate}}</td>
                  <td class="icon">
                      <i *ngIf="denominacion.permisoLecturaDataMatrixPublica === true" class="fa-regular fa-circle-check" title="{{'titles.permisoLectura' | translate}}"></i>
                      <i *ngIf="denominacion.permisoLecturaDataMatrixPublica === false" style="color:red" class="fa-regular fa-circle-xmark" title="{{'titles.sinPermisoLectura' | translate}}"></i>
                  </td>
                  <td class="multi-actions-bigger">
                      <i class="fas fa-stream" app-click-stop-propagation (click)="showSection(i, denominacion.id)"
                         title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                      <i *ngIf="role === 'Administrador'" class="fas fa-upload" title="{{'titles.imagenColorAsociados' | translate}}" app-click-stop-propagation (click)="openImageColorModal(denominacion.id, denominacion.des)"></i>
                      <i class="fas fa-pencil-alt" app-click-stop-propagation (click)="update(denominacion)"
                         title="{{'titles.editar' | translate}}"></i>
                      <i class="far fa-trash-alt" [ngClass]="{'disabled': denominacion.registroEnUso}" app-click-stop-propagation (click)="askDelete(denominacion)"
                         title="{{'titles.eliminar' | translate}}"></i>
                  </td>
              </tr>
              <tr *ngIf="dropdownInfo === i">
                <td colspan="10">
                  <div class="detail">
                    <div class="title">{{'global.masInformacion' | translate}}</div>
                    <div class="block-inline">
                      <label>{{'mantenimientoDenominaciones.table.etiquetaCaja' | translate}}</label>
                      <p>
                        {{denominacion.desDisenyoEtiquetaCaja ? denominacion.desDisenyoEtiquetaCaja : 'Sin diseño de etiqueta'}}
                      </p>
                    </div>
                    <div class="block-inline">
                      <label>{{'mantenimientoDenominaciones.table.etiquetaPallet' | translate}}</label>
                      <p>
                        {{denominacion.desDisenyoEtiquetaPallet ? denominacion.desDisenyoEtiquetaPallet : 'Sin diseño de etiqueta'}}
                      </p>
                    </div>
                    <div class="block-inline">
                      <label>{{'global.fecha.insercionShort' | translate}}</label>
                      <p>
                        {{denominacion.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}
                      </p>
                    </div>
                    <div class="block-inline">
                      <label>{{'global.fecha.actualizacionShort' | translate}}</label>
                      <p>
                        {{denominacion.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="dropdownSection === i">
                  <td colspan="13">
                      <section class="tabs">
                          <ul>
                              <li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="changeActiveTab(i, 1)">
                                {{ 'mantenimientoDenominaciones.table.paisesProduce' | translate }}</li>
                              <li [ngClass]="{'active': pestanaActiva[i] === 2}" (click)="changeActiveTab(i, 2)">
                                {{ 'mantenimientoDenominaciones.proteccion.title' | translate }}</li>
                          </ul>
                          <content>
                              <app-pais-denominacion *ngIf="pestanaActiva[i] === 1" [denominacion]="denominacion" (pushMessage)="pushMessage($event)" (refresh_)="refresh($event)"></app-pais-denominacion>
                              <app-proteccion-denominacion *ngIf="pestanaActiva[i] === 2" [denominacionId]="toEditId"></app-proteccion-denominacion>
                          </content>
                      </section>
                  </td>
              </tr>
          </tbody>
          <tfoot *ngIf="!denominaciones || (denominaciones && denominaciones.length < 1)">
              <tr>
                  <td colspan="11">
                      {{'global.noContent' | translate}}
                  </td>
              </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <app-paginator *ngIf="denominaciones && denominaciones.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{toEditId ? ('mantenimientoDenominaciones.tituloEdit' | translate) : ('mantenimientoDenominaciones.tituloNew' | translate)}}</h4>
        </header>
        <app-dns-new-edit [denominacionId]="toEditId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-dns-new-edit>
    </div>
</div>

<div class="modal" *ngIf="imageColorModal">
  <div class="modal-content">
    <header>
      <h4>{{'titles.imagenColorAsociados' | translate}}</h4>
    </header>
    <app-imagen-color-denominacion [denominacionId]="toEditId" [desDenominacion]="toEditDes" (refresh)="closeImageColorModal()" (mensaje)="pushMessage($event)"></app-imagen-color-denominacion>
  </div>
</div>
